import axios from 'axios';
import packageJson from '../../package.json';
import { Capacitor } from '@capacitor/core';

// In native app, relative paths don't work, so we default to the secure DuckDNS server domain.
const DEFAULT_NATIVE_API_URL = 'https://homeinven.duckdns.org/api';

const getApiUrl = () => {
  if (Capacitor.isNativePlatform()) {
    return process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL !== '/api'
      ? process.env.REACT_APP_API_URL
      : DEFAULT_NATIVE_API_URL;
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:8000';
};

const API_URL = getApiUrl();
export const APP_VERSION = process.env.REACT_APP_VERSION || packageJson.version;

const client = axios.create({
  baseURL: API_URL,
});

// Request interceptor for API calls
client.interceptors.request.use(
  async config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = { 
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
        ...config.headers
      }
    }
    return config;
  },
  error => {
    Promise.reject(error)
});

// Response interceptor for API calls
client.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config;
  if (error.response?.status === 401 && !originalRequest._retry) {
    // Token might be expired
    localStorage.removeItem('token');
    window.location.href = '/'; // Redirect to login
    return Promise.reject(error);
  }
  return Promise.reject(error);
});

export default client;
export { API_URL };
